/* GeneratedContentHash: e777aebd45334219b85dee4ca47450fe23f5d4b99871ee7d70198bcb6ff8a917 */
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { createRender } from './types';

export const render = createRender(() => <button>{`Hello world!`}</button>);

export default render;
